import Validator from '../validator';

const isPasswordLengthValid = string => string?.trim()?.length >= 8;

export default class PasswordLengthValidator extends Validator {
  static validate(string) {
    return isPasswordLengthValid(string);
  }
}
